module.exports = __webpack_public_path__ + "static/img/photo-01-big.68db56c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-01-big.jpg
// module id = 1RMc
// module chunks = 1